<template>
	<div class="box">
		<ComNar title = "星巴克点餐系统"></ComNar>
		<div class="image-div">
			<div class="title-div">服务时间为早8:00至21:00</div>
			<div class="btn-div" @click="toSearchShop">
				<van-button type="info" round>我知道了</van-button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import ComNar from '../components/searchShop/ComNar.vue'
	import {
		Button
	} from 'vant';
	export default {
		name:'unSell',
		components:{
			 [ComNar.name]: ComNar,
			 [Button.name]: Button,
		},
		created() {
			
		},
		
		data(){
			return {
				
			}
		},
		methods:{
			toSearchShop(){
				this.$router.push("searchShop");
			}
		}
	}
</script>

<style scoped>
	
	.image-div {
		margin-top: 50px;
		width: 100%;
		height: 346px;
		background-image: url(../assets/unsell.png);
		background-size: 100% 100%;
		border-radius: 15px;
		position: relative;
	}
	
	.title-div {
		position: absolute;
		width: 100%;
		height: max-content;
		text-align: center;
		font-size: 20px;
		color: #346750;
		left: 0;
		bottom: 161px;
	}
	
	.btn-div {
		position: absolute;
		width: 100%;
		height: max-content;
		text-align: center;
		left: 0;
		bottom: 60px;
	}
	
	.btn-div /deep/ .van-button {
		background-color: #346750;
		border-color: #346750;
		width: 280px;
		font-size: 18px;
		color: #ffffff;
	}
</style>
